// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type AsyncJobFailedObject,
  type AsyncJobFailedObjectWireFormat,
  NewAsyncJobFailedObject,
} from '../AsyncJobFailedObject/AsyncJobFailedObject';
import Enums from '../Enums';

export class AsyncJobDetail {
  readonly id: string;
  readonly jobType: Enums.AsyncJobType;
  readonly status: Enums.AsyncJobStatus;
  readonly itemsTotal: number;
  readonly itemsProcessed: number;
  readonly itemsFailed: number;
  readonly errorMessage: string | null;
  readonly createdAt: DateTime;
  readonly succeededObjectIds: string[];
  readonly failedObjectIds: string[];
  readonly failedObjects: AsyncJobFailedObject[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.jobType =
      data.jobType === undefined ? Enums.AsyncJobType.QuotePricingUpdate : data.jobType;
    this.status = data.status === undefined ? Enums.AsyncJobStatus.Pending : data.status;
    this.itemsTotal = data.itemsTotal === undefined ? 0 : data.itemsTotal;
    this.itemsProcessed = data.itemsProcessed === undefined ? 0 : data.itemsProcessed;
    this.itemsFailed = data.itemsFailed === undefined ? 0 : data.itemsFailed;
    this.errorMessage = data.errorMessage === undefined ? null : data.errorMessage;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.succeededObjectIds = (data.succeededObjectIds ?? []).map((succeededObjectIds: any) =>
      succeededObjectIds === undefined ? NIL_UUID : succeededObjectIds,
    );
    this.failedObjectIds = (data.failedObjectIds ?? []).map((failedObjectIds: any) =>
      failedObjectIds === undefined ? NIL_UUID : failedObjectIds,
    );
    this.failedObjects = (data.failedObjects ?? []).map((failedObjects: any) =>
      NewAsyncJobFailedObject(failedObjects),
    );
  }

  static zero(): AsyncJobDetail {
    const zeroValues: ExcludeMethodsDeep<AsyncJobDetail> = {
      id: NIL_UUID,
      jobType: Enums.AsyncJobType.QuotePricingUpdate,
      status: Enums.AsyncJobStatus.Pending,
      itemsTotal: 0,
      itemsProcessed: 0,
      itemsFailed: 0,
      errorMessage: null,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      succeededObjectIds: [],
      failedObjectIds: [],
      failedObjects: [],
    };
    return new AsyncJobDetail(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AsyncJobDetailWireFormat = {
  id: string;
  jobType: string;
  status: string;
  itemsTotal: number;
  itemsProcessed: number;
  itemsFailed: number;
  errorMessage: string | null;
  createdAt: string;
  succeededObjectIds: string[];
  failedObjectIds: string[];
  failedObjects: AsyncJobFailedObjectWireFormat[];
};

type NewAsyncJobDetailProps = PartialDeep<AsyncJobDetail, { recurseIntoArrays: true }>;
export const NewAsyncJobDetail: (props: NewAsyncJobDetailProps) => AsyncJobDetail = (props) =>
  new AsyncJobDetail(props);

type NewAsyncJobDetailFromWireFormatProps = PartialDeep<
  AsyncJobDetailWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAsyncJobDetailFromWireFormat: (
  props: NewAsyncJobDetailFromWireFormatProps,
) => AsyncJobDetail = (props) => new AsyncJobDetail(props);
